import styled from 'styled-components';

export const ThankRightOuterWrap = styled.div(
  props => `
      flex: 1;
      display: flex;
      flex-direction: column;
      padding-left: 20px;  
  `
);

export const ThankYouRightInnerWrap = styled.div(
  props => `
      width: 100%;
      display: flex;
      flex-direction: column;
      border-radius: 1rem;
      box-shadow: 0 3px 30px 0 rgba(0, 0, 0, 0.1);
      background-color: ${props.theme.colors.white.base};
  `
);

export const ManagerBkngWrap = styled.div(
  props => `
      display: flex;
      padding: ${props.theme.spacing.large.l14} ${props.theme.spacing.large.l20};
      flex-direction: column; 
  `
);

export const ManageBkgHeadTex = styled.p(
  props => `
      font-size: ${props.theme.font.large.font18};
      color: ${props.theme.colors.black.base};
      font-weight: ${props.theme.font.fontWeight.black};
  `
);

export const ManageBkngSubText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font14};
      color: ${props.theme.colors.grey.base};
      padding: ${props.theme.spacing.base} 0;
      span{
          font-weight: ${props.theme.font.fontWeight.black};
      }
      
  `
);

export const ManagerMyTripText = styled.a(
  props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.blue.base};
      font-weight: ${props.theme.font.fontWeight.black};
      cursor: pointer;
  `
);

export const ContactUsWrap = styled.div(
  props => `
      display: flex;
      padding: ${props.theme.spacing.large.l14} ${props.theme.spacing.large.l20};
      flex-direction: column; 
      border-top: 1px solid ${props.theme.colors.grey.lighte7};
  `
);

export const ContactInfoWrap = styled.div(
  props => `
      display: flex;
      padding-top: ${props.theme.spacing.small.s5};
  `
);

export const ContantInfoText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font14};
      color: ${props.theme.colors.grey.base};
  `
)
